import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./global.css";

import Nav from "./components/Nav";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Services from "./components/Services";
import Products from "./components/Products";
import Solutions from "./components/Solutions";
import Client from "./components/Clients";
import Partners from "./components/Partners";
import ScrollToTopButton from "./components/Scrollbtn";

import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

/* -------------------------------
   Reusable Animated Wrapper
--------------------------------*/
const Section = ({ children }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.15,
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{
        duration: 0.6,
        ease: "easeOut",
      }}
    >
      {children}
    </motion.div>
  );
};

/* -------------------------------
   App Layout
--------------------------------*/
function App() {
  return (
    <Router>
      <div className="w-full font-sans overflow-x-hidden">


          <Nav />

          <Section>
            <Home />
          </Section>

          <Section>
            <About />
          </Section>

          <Section>
            <Services />
          </Section>

          <Section>
            <Products />
          </Section>

          <Section>
            <Client />
          </Section>

          <Section>
            <Solutions />
          </Section>

          <Section>
            <Partners />
          </Section>

          <Section>
            <Contact />
          </Section>

          <ScrollToTopButton />
        </div>
    </Router>
  );
}

export default App;